import { Button, Grid, useTheme } from '@mui/material';
import { MitIDLogo } from '@resurs-internal/mui';
import { useCallback, useState } from 'react';

import NorwegianBankId from '../../assets/svg/NorwegianBankId';
import useSettings from '../../hooks/useSettings';
import { ButtonStyles } from './Login.styles';

type Props = {
    dispatchInitAuthentication: () => void;
    translate: (key: string) => string;
};

const LoginButton = ({ dispatchInitAuthentication, translate }: Props) => {
    const [isLoggingIn, setLoggingIn] = useState(false);
    const { countryCode } = useSettings();
    const theme = useTheme();

    const onLogin = useCallback(() => {
        setLoggingIn(true);
        dispatchInitAuthentication();
    }, [setLoggingIn]);

    return (
        <Button onClick={onLogin} disabled={isLoggingIn} fullWidth variant="contained" sx={ButtonStyles}>
            <Grid container spacing={2}>
                <Grid alignSelf="center">{translate(`page.authentication.submit.log.in.button`)}</Grid>
                <Grid>
                    {countryCode === 'NO' && <NorwegianBankId />}
                    {countryCode === 'DK' && <MitIDLogo size="xl" color={theme.palette.primary.contrastText} />}
                </Grid>
            </Grid>
        </Button>
    );
};

export default LoginButton;
